import useToggle from "@casino/legacy/client/hooks/useToggle";
import Script from "next/script";

const TelegramScript: FC = () => {
  const [isLoaded, handleLoad] = useToggle();
  const telegramBotName = `${global.location?.hostname.replace(
    /[.-]/g,
    "",
  )}_bot`;

  return (
    <>
      <Script
        id="telegram-lib"
        strategy="lazyOnload"
        onLoad={handleLoad}
        data-telegram-login={telegramBotName}
        data-size="small"
        data-request-access="write"
        data-userpic="false"
        src="https://telegram.org/js/telegram-widget.js"
        async
      />
      {isLoaded && <Script id="telegram-lib" strategy="lazyOnload" />}
    </>
  );
};

export default TelegramScript;
